__turbopack_context__.v({
  "actions": "DeployAsAgentButton-module__Q26g8q__actions",
  "btn": "DeployAsAgentButton-module__Q26g8q__btn",
  "btnPrimary": "DeployAsAgentButton-module__Q26g8q__btnPrimary",
  "btnSecondary": "DeployAsAgentButton-module__Q26g8q__btnSecondary",
  "btnSm": "DeployAsAgentButton-module__Q26g8q__btnSm",
  "compact": "DeployAsAgentButton-module__Q26g8q__compact",
  "gateActions": "DeployAsAgentButton-module__Q26g8q__gateActions",
  "gateStrip": "DeployAsAgentButton-module__Q26g8q__gateStrip",
  "gateText": "DeployAsAgentButton-module__Q26g8q__gateText",
  "mono": "DeployAsAgentButton-module__Q26g8q__mono",
  "panel": "DeployAsAgentButton-module__Q26g8q__panel",
  "panelActions": "DeployAsAgentButton-module__Q26g8q__panelActions",
  "panelBezel": "DeployAsAgentButton-module__Q26g8q__panelBezel",
  "panelBezelLabel": "DeployAsAgentButton-module__Q26g8q__panelBezelLabel",
  "panelBezelLeft": "DeployAsAgentButton-module__Q26g8q__panelBezelLeft",
  "panelBezelStatus": "DeployAsAgentButton-module__Q26g8q__panelBezelStatus",
  "panelBody": "DeployAsAgentButton-module__Q26g8q__panelBody",
  "panelEyebrow": "DeployAsAgentButton-module__Q26g8q__panelEyebrow",
  "panelMark": "DeployAsAgentButton-module__Q26g8q__panelMark",
  "panelNote": "DeployAsAgentButton-module__Q26g8q__panelNote",
  "panelText": "DeployAsAgentButton-module__Q26g8q__panelText",
  "panelTitle": "DeployAsAgentButton-module__Q26g8q__panelTitle",
  "wrap": "DeployAsAgentButton-module__Q26g8q__wrap",
});
